import { Box } from '@mui/material'
import { ReactComponent as HealthLogo } from 'assets/icons/health-logo.svg'
import { getFatnessColorByTable } from 'components/cattles/fatnessPage/shared/fatnessScoreColor'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import { CardStandart } from 'ui/CardStandart'
import InfoChipItem from 'ui/InfoChipItem'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'

const FatnessWidjet = props => {
	const { fatness, lastMilking, lactationDay } = props
	const isNoDataValue = (value: unknown) =>
		value == null ||
		(typeof value === 'string' &&
			(value.trim() === '' || value.trim().toLowerCase() === 'нет данных'))
	const hasFatness = !isNoDataValue(fatness)
	const hasLastMilking = !isNoDataValue(lastMilking)
	const fatnessCategoryColor = getFatnessColorByTable(
		hasFatness ? Number(fatness) : null,
		typeof lactationDay === 'number' ? lactationDay : null,
	)
	const isOutOfRange =
		hasFatness && (Number(fatness) < 2.25 || Number(fatness) > 4)
	const fatnessTextColor = isOutOfRange ? COLORS.error : COLORS.black
	const iconColor =
		fatnessCategoryColor === COLORS.error ? COLORS.error : COLORS.secondary

	return (
		<CardStandart
			sx={{
				width: '100%',
				padding: '24px',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
			}}
		>
			<Box display={'flex'} flexDirection={'row'} gap={'8px'} mr={'4px'}>
				<span>
					<HealthLogo fill={iconColor} stroke={iconColor} />
				</span>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',
						gap: '8px',
					}}
				>
					{hasFatness ? (
						<TypographyPrimary16Bold sx={{ color: fatnessTextColor }}>
							{fatness}{' '}
							<span
								style={{
									color: COLORS.secondary,
									fontWeight: 400,
									fontSize: '12px',
								}}
							>
								балла
							</span>
						</TypographyPrimary16Bold>
					) : (
						<TypographySecondary>Нет данных</TypographySecondary>
					)}

					<TypographySecondary>Упитанность</TypographySecondary>
				</Box>
			</Box>
			<Box
				display={'flex'}
				flexDirection={'column'}
				justifyContent={isOutOfRange ? 'space-between' : 'flex-end'}
				gap={'8px'}
			>
				{isOutOfRange && (
					<InfoChipItem
						bgColor={COLORS.error10}
						label={'Обратите внимание'}
						labelColor={COLORS.error}
					/>
				)}
				{hasLastMilking && (
					<TypographySecondary alignSelf={'flex-end'}>
						{`замер ${moment(lastMilking).format('D.MM.YY')}`}
					</TypographySecondary>
				)}
			</Box>
		</CardStandart>
	)
}

export default FatnessWidjet
